'use client'

import type { FC } from 'react'

export interface FieldWrapperProps {
    fieldName: string
    error?: string
    children: React.ReactNode
}

const FieldWrapper: FC<FieldWrapperProps> = ({ fieldName: _fieldName, error, children }) => {
    return (
        <div className='form-group'>
            {children}
            {error && <p className='text-destructive text-sm'>{error}</p>}
        </div>
    )
}

export default FieldWrapper
